import {useState} from 'react';
import {ScrollView, StyleSheet, View} from 'react-native';
import {Title, Subheading, TextInput, Text, Button} from 'react-native-paper';
import {useAppSettings} from '../components/AppSettings';
import {createHeaders} from '../hooks/useFunctions';
import {getApiUrl} from '../AppConfig';
import {useAlerts} from 'react-native-paper-alerts';

function AdminTools() {
  const Alert = useAlerts();
  const appSettings = useAppSettings();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const themedStyles = StyleSheet.create({
    outlinedVertically: {
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: appSettings.currentTheme.colors.primary,
    },
  });

  const handleGeneratePassword = async () => {
    if (!email) {
      return;
    }
    setLoading(true);
    try {
      const accountAPI = getApiUrl() + 'user/password';
      const result = await fetch(accountAPI, {
        headers: await createHeaders(),
        method: 'POST',
        body: JSON.stringify({email}),
      });
      const response = await result.json();
      if (result.status === 500 || response.error !== undefined) {
        throw new Error(response.error);
      }
      // console.log(`got API response ${JSON.stringify(response, null, 2)}`);
      setEmail('');
      Alert.alert(
        'New Password',
        `User ${response.data.email} has new password ${response.data.password}`,
        [{text: appSettings.t('OK')}],
      );
    } catch (e) {
      Alert.alert('Error', '' + e, [{text: appSettings.t('OK')}]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView persistentScrollbar={true} style={[styles.container]}>
      <View style={styles.horizontalCentered}>
        <Title style={styles.title}>Admin Tools</Title>
      </View>
      <View style={styles.content}>
        <Subheading style={[styles.title, themedStyles.outlinedVertically]}>
          Generate User Password
        </Subheading>
        <View style={[styles.horizontalCentered, styles.content]}>
          <Text>Email address: </Text>
          <TextInput
            mode="outlined"
            dense
            editable={!loading}
            keyboardType="email-address"
            autoCapitalize="none"
            onChangeText={text => setEmail(text)}
            value={email}
          />
        </View>
        <View style={[styles.horizontalCentered, styles.content]}>
          <Button
            mode="outlined"
            compact
            disabled={loading || !email}
            onPress={() => handleGeneratePassword()}>
            Generate Password
          </Button>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
    padding: 20,
    marginVertical: 20,
  },
  content: {
    paddingHorizontal: 40,
  },
  title: {
    padding: 10,
    paddingHorizontal: 20,
  },
  horizontalCentered: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
    paddingHorizontal: 10,
  },
});

export default AdminTools;
